import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { withRouter } from 'react-router-dom';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import UserTypeSettings from './UserTypeSettings';

class UserTypePage extends Component {
  constructor() {
    super();
    this.state = {
      
    };
  }

  render() {
    const { organization, location } = this.props;
    const isDemo = organization && organization.is_demo;

    
    return (
      <div>
        <Helmet title="Manage User Types" />
        <div className="container">
          {!isDemo &&
            <div className="well well-sm">
              <div>
                <p>
                  Select the user type(s) that will be excluded from the data sync.
                </p>
              </div>
            </div>
          }
          {isDemo &&
            <div className="alert alert-warning">
              This is a demo organization, please switch back to the original organization to change the settings.
            </div>
          }

          {!isDemo &&
            <UserTypeSettings />
          }
        </div>
       
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

UserTypePage.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  organization: PropTypes.shape({}).isRequired,
};

UserTypePage.contextTypes = {
};

export default connect(mapStateToProps)(withRouter(UserTypePage));
